import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import AccountingDashboard from './Accounting';
import AdOpsDashboard from './AdOps';
import Collabary from './Collabary';
import LeadDashboard from './Lead';
import PCDashboard from './PC';
import SalesBackofficeDashboard from './SalesBackoffice';

function Routes() {
  return (
    <DocumentTitle title="Dashboard">
      <Route path="/dashboard/pc" component={PCDashboard} />
      <Route path="/dashboard/adops" component={AdOpsDashboard} />
      <Route path="/dashboard/accounting" component={AccountingDashboard} />
      <Route path="/dashboard/lead" component={LeadDashboard} />
      <Route
        path="/dashboard/salesbackoffice"
        component={SalesBackofficeDashboard}
      />
      <Route path="/dashboard/collabary" component={Collabary} />
    </DocumentTitle>
  );
}

export default Routes;
export { default as DefaultDashboard } from './Dashboard';
